/**
 * Feedback List Component
 * 
 * Renders list of feedback cards.
 * Passes auth callback to cards for guest users.
 */
import FeedbackCard from './FeedbackCard';
import { __ } from '@wordpress/i18n';

const FeedbackList = ({ 
    feedback, 
    loading, 
    statuses = {},
    onUpvote, 
    onDownvote,
    onCardClick, 
    isLoggedIn, 
    currentUser,
    isPremium,
    enableDownvoting = false,
    onAuthRequired
}) => {
    if (loading) {
        return (
            <div className="cha-feedback-loading">
                <div className="cha-spinner"></div>
                <p>{__( 'Loading feedback...', 'changeloger' )}</p>
            </div>
        );
    }

    if (!feedback || feedback.length === 0) {
        return (
            <div className="cha-feedback-empty">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                </svg>
                <h3>{__( 'No feedback yet', 'changeloger' )}</h3>
                <p>{__( 'Be the first to submit feedback!', 'changeloger' )}</p>
            </div>
        );
    }

    return (
        <div className="cha-feedback-list">
            {feedback.map(item => (
                <FeedbackCard 
                    key={item.id}
                    item={item}
                    statuses={statuses}
                    onUpvote={onUpvote}
                    onDownvote={onDownvote}
                    onCardClick={onCardClick}
                    isLoggedIn={isLoggedIn}
                    isPremium={isPremium}
                    currentUser={currentUser}
                    enableDownvoting={enableDownvoting}
                    onAuthRequired={onAuthRequired}
                />
            ))}
        </div>
    );
};

export default FeedbackList;
